(function () {
    const scriptSrc = document.currentScript.getAttribute('data-section');
    const imageTextSlideshow = () => {
        var current_section = window.document.querySelector('[id$="' + scriptSrc + '"]');
        var imageTextSlideshow = current_section.querySelector('.slideshow-text-image__carousel');
        if (!imageTextSlideshow) {
            return;
        }

        var columnsFlickity = jQuery(imageTextSlideshow).flickity({
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            freeScroll: false,
            pageDots: false,
            prevNextButtons: false,
            groupCells: false,
            draggable: true,
            adaptiveHeight: true,
            arrowShape: {
                x0: 10,
                x1: 60, y1: 50,
                x2: 60, y2: 40,
                x3: 20
              }
        });
        let flkty = columnsFlickity.data('flickity');
        let columnsLength = flkty.slides.length;

        // previous
        let previousButton = current_section.querySelector('.button--previous');
        if (previousButton) {
            previousButton.addEventListener('click', function () {
                columnsFlickity.flickity('previous');
            });
        }
        // next
        let nextButton = current_section.querySelector('.button--next');
        if (nextButton) {
            nextButton.addEventListener('click', function () {
                columnsFlickity.flickity('next');
            });
        }

        // if (nextButton && previousButton) {
        //     columnsFlickity.on('select.flickity', function (event, index) {
        //         if (index === 0) {
        //             previousButton.classList.add('hidden');
        //             nextButton.classList.remove('hidden');
        //         } else if (index === columnsLength - 3) {
        //             previousButton.classList.remove('hidden');
        //             nextButton.classList.add('hidden');
        //         } else {
        //             previousButton.classList.remove('hidden');
        //             nextButton.classList.remove('hidden');
        //         }
        //     });
        // }

    };

    window.addEventListener('load', function () {
        imageTextSlideshow();
    });
})();